export default __webpack_public_path__ + "static/media/pb.83998914.jpg";